import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { creFadeInOut, NotificationService } from 'cre-ng';

import { User } from '@app/core/core.model';
import { IDriverWigService } from '@app/core/services/interface/IDriverWigService';
import { ServiceFactory } from '@app/core/services/service.factory';
import { AuthService } from '@app/core/auth.service';
import { Daily5Model } from './wig-daily5-form.model';

@Component({
  animations: [creFadeInOut],
  selector: 'app-wig-daily5',
  styleUrls: ['./wig-daily5-form.component.css'],
  templateUrl: './wig-daily5-form.component.html',
})
export class WigDaily5Component implements OnInit {
  @Output() formCompleted = new EventEmitter<boolean>();
  @Input() tractorId: number;
  driverWigService: IDriverWigService;
  isSaving: boolean;
  model: Daily5Model;
  private currentUser: User;

  constructor(
    private authService: AuthService,
    private serviceFactory: ServiceFactory,
    private notificationService: NotificationService
  ) {
    this.driverWigService = serviceFactory.getDriverWigService();
  }

  ngOnInit() {
    this.currentUser = this.authService.getCurrentUser();
    this.isSaving = false;
    this.model = new Daily5Model({
      appt: undefined,
      eta: undefined,
      pta: undefined,
      runningOnTime: undefined,
      hoursPerDay: undefined,
      tractorId: this.tractorId,
    });
  }

  submitDaily5() {
    this.isSaving = true;
    this.driverWigService
      .saveDaily5(this.model)
      .then((x) => {
        if (x && x.includes('true')) {
          this.notificationService.showSuccess(
            'Success',
            'Thank you for completing your Daily 5 form'
          );
          this.formCompleted.emit(true);
        } else {
          this.notificationService.showError('Error Responding', x);
        }
      })
      .catch((e) => {
        this.notificationService.showError(
          'Error Responding',
          'Form couldn\'t be saved successfuly.'
        );
      })
      .finally(() => {
        this.isSaving = false;
      });
  }
}
